<template>
	<div class="box-menu">
		<div class="box-menu-img" @click="$router.push({ name: 'LandPageParceiro' })">
			<div style="text-align: center; padding: 0 10px; @media only screen and (min-width: 990px) {width: 500px}">
				<img v-if="parceiro" :src="parceiroConfig.logo" />
				<img v-else src="../../assets/images/logo.png" />
				<h6 class="text-description">
					{{ parceiroConfig.sessoes.customization && parceiroConfig.sessoes.customization.campos.menuDebits && parceiroConfig.sessoes.customization.campos.menuDebits.textAbaixoLogo ? parceiroConfig.sessoes.customization.campos.menuDebits.textAbaixoLogo : "Negocie seus débitos com descontos e volte a ter crédito para comprar novamente!" }}
				</h6>
			</div>
		</div>
		<div class="box-menu-options">
			<!--            <div class="slim" v-if="returnRouterName === 'Register'">-->
			<!--                <land-page-search :mode="'slim'"/>-->
			<!--            </div>-->
			<div class="namePage" v-if="returnRouterName === 'AccordionTabs'">
				<h5 style="text-transform: capitalize">Olá, {{ pessoa }}</h5>
			</div>
			<div class="namePage" v-else>
				<template v-if="returnRouterName === 'MyDebits'">
					<h5>Minhas Dívidas</h5>
				</template>
				<template v-else-if="returnRouterName === 'MyAgreements'">
					<h5>Meus Acordos</h5>
				</template>
				<template v-else-if="returnRouterName === 'TalkToUs'">
					<h5>Fale Conosco</h5>
				</template>
				<template v-else-if="returnRouterName === 'FAQ'">
					<h5>Dúvidas</h5>
				</template>
				<h6 class="button-back" :style="corPrimaria" @click="returnRouterName === 'AccordionTabs' ? $router.push({ name: 'LandPageParceiro' }) : $router.go(-1)">
					<i class="fas fa-arrow-left" />
					VOLTAR
				</h6>
			</div>
			<div @click="showMobile = true" class="box-bar">
				<i class="fas fa-bars" />
			</div>
			<div class="menu-background-full" v-if="showMobile">
				<div>
					<i class="fas fa-times" @click="showMobile = false" />
					<img v-if="parceiro" :src="parceiroConfig.logo" />
					<img v-else src="../../assets/images/logo.png" />
				</div>
				<div>
					<h5 style="font-size: 24px; text-transform: uppercase; margin-bottom: 5px; text-align: center; color: #ffffff; font-family: 'Roboto Bold'">
						<template v-if="returnRouterName === 'MyDebits'"> Minhas Dívidas </template>
						<template v-else-if="returnRouterName === 'MyAgreements'"> Meus Acordos </template>
						<template v-else-if="returnRouterName === 'TalkToUs'"> Fale Conosco </template>
						<template v-else-if="returnRouterName === 'FAQ'"> Dúvidas </template>
					</h5>
					<h5 style="margin-bottom: 30px; font-size: 14px; text-align: center; color: #ffffff; font-family: 'Roboto'"></h5>
				</div>
				<div>
					<ButtonDefault text="Voltar para página inicial" :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="returnRouterName === 'AccordionTabs' ? $router.push({ name: 'LandPageParceiro' }) : $router.go(-1)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LandPageSearch from "../landPage/components/LandPageSearch";
import { mapState } from "vuex";
import ButtonDefault from "../../components/buttons/ButtonDefault";
import Template from "../admin/Template";
export default {
	name: "MenuDebits",
	components: { Template, ButtonDefault, LandPageSearch },
	data() {
		return {
			showMobile: false
		};
	},
	computed: {
		...mapState({
			pessoa: (state) => state.pessoa,
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			corPrimaria: (state) => state.corPrimaria,
			corSecundaria: (state) => state.corSecundaria
		}),
		returnRouterName() {
			return this.$route.name;
		}
	},
	mounted() {
		window.fbq("trackCustom", "Menu de Dívidas");
	}
};
</script>

<style scoped lang="scss">
.box-menu {
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	flex: 1;
	width: 100%;
	@media only screen and (min-width: 990px) {
		min-height: 100vh;
	}
	@media only screen and (max-width: 990px) {
		flex-direction: row;
		height: 130px;
	}
}
.box-menu-img {
	width: 100%;
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	padding-bottom: 30px;
	box-sizing: border-box;
	cursor: pointer;
	@media only screen and (max-width: 990px) {
		padding: 0;
		height: 100px;
		width: 100vw;
		align-items: center;
		justify-content: flex-start;
	}
}

.box-menu-img img {
	max-width: 300px;
	max-height: 300px;
	@media only screen and (max-width: 990px) {
		max-width: 200px;
		max-height: 150px;
		padding-left: 30px;
	}
}

.box-menu-img h6 {
	color: var(--whiteColor);
	margin-top: 30px;
	font-family: "Roboto Light";
	font-size: 24px;
	line-height: 32px;
	@media only screen and (max-width: 990px) {
		display: none !important;
	}
}

.box-menu-options {
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	padding-top: 30px;
	box-sizing: border-box;
	@media only screen and (max-width: 990px) {
		padding-top: 0;
	}
}

.slim {
	padding-bottom: 50px;
}

.slim,
.name-box-menu {
	@media only screen and (max-width: 990px) {
		display: none;
	}
}

.box-bar,
.box-bar i {
	font-size: 32px !important;
	@media only screen and (min-width: 990px) {
		display: none !important;
	}
}

.box-menu-options h2 {
	color: var(--whiteColor);
	font-family: Montserrat-Regular;
	font-size: 18px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
}

.box-bar {
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-end;
	width: 100%;
	padding-right: 30px;
}

.box-bar i {
	color: #ffffff;
	font-size: 24px;
}

.namePage {
	width: 100%;
	padding: 0 0 30px 30px;
	@media only screen and (max-width: 990px) {
		display: none !important;
	}
}

.namePage h5 {
	width: 100%;
	color: rgba(255, 255, 255, 0.5);
	font-family: Montserrat-Regular;
	font-size: 18px;
	border-bottom: 1px solid #28394e;
	line-height: 70px;
	margin-bottom: 30px;
}

h6.text-description {
	color: rgba(255, 255, 255, 0.5);
	font-family: Montserrat-Regular;
	font-size: 18px;
	padding: 0 20px;
}

.namePage h6 {
	color: rgba(255, 255, 255, 0.5);
	font-family: Montserrat-Regular;
	font-size: 18px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}

.namePage h6 i {
	font-size: 18px;
	margin-right: 10px;
}

.button-back {
	background: var(--color);
	display: flex;
	padding: 25px;
	width: 100%;
	border-top-left-radius: 50px;
	border-bottom-left-radius: 50px;
	transition: all 0.2s ease-in-out;
}

h6.button-back i {
	font-size: 24px;
}

.button-back:hover {
	cursor: pointer;
	background: var(--hovercolor);
	transition: all 0.2s ease-in-out;
}

h6.button-back {
	color: #ffffff;
	font-family: Montserrat-Bold;
}

.menu-background-full {
	position: fixed;
	width: 100%;
	min-height: 100vh;
	left: 0;
	top: 0;
	background: var(--blackColor);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	z-index: 999;
	padding: 15vh 0;
}

.menu-background-full img {
	margin-bottom: 35px;
	width: 250px;
}

.menu-background-full i {
	font-size: 38px;
	color: var(--whiteColor);
	position: absolute;
	right: 5vw;
	top: 2vh;
}

.menu-background-full ul li {
	font-size: 32px;
	font-family: Cabin;
	margin: 40px 0;
	color: var(--whiteColor);
	cursor: pointer;
}

.menu-background-full li a {
	margin: 0;
	font-size: 32px;
	color: var(--whiteColor);
	font-family: Cabin;
	text-align: center;
}

.menu-background-full li.button-header {
	border: 4px solid #ffffff;
	padding: 15px 30px;
	border-radius: 27px;
	text-align: center;
	margin-top: 60px;
}
</style>
